import cbos from '@/data/cbos.js';

export default {
  namespaced: true,
  state: {
    cbos,
  },
};
